import { TableTemplate } from 'types/tableTemplate';

export const procedureTableTemplate: TableTemplate[] = [
  {
    id: 'name',
    description: 'Procedimento',
    originalId: 'name',
    width: 300,
  },
  {
    id: 'formattedSpecialties',
    description: 'Especialidades',
    originalId: 'formattedSpecialties',
    width: 220,
  },
  {
    id: 'doctorsCount',
    description: 'Médicos',
    originalId: 'doctorsCount',
    width: 100,
    dataType: 'number',
  },
  {
    id: 'packagesCount',
    description: 'Pacotes',
    originalId: 'packagesCount',
    width: 100,
    dataType: 'number',
  },
  {
    id: 'productsCount',
    description: 'Produtos',
    originalId: 'productsCount',
    width: 100,
    dataType: 'number',
  },
  {
    id: 'formattedProfitMargin',
    description: 'Margem de Lucro',
    originalId: 'profit_margin',
    width: 140,
    dataType: 'number',
  },
  {
    id: 'formattedActive',
    description: 'Status',
    originalId: 'active',
    width: 110,
  },
];
